import { render, staticRenderFns } from "./sponsored-score-feature-container.component.vue?vue&type=template&id=acf1d012&scoped=true"
import script from "./sponsored-score-feature-container.component.vue?vue&type=script&lang=ts"
export * from "./sponsored-score-feature-container.component.vue?vue&type=script&lang=ts"
import style0 from "./sponsored-score-feature-container.component.vue?vue&type=style&index=0&id=acf1d012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf1d012",
  null
  
)

export default component.exports